export const DOC_FLOW_WIDGETS_SPLITTING_MAPPING_PERMANENT_NOTIFICATION_ID =
  'splittingAndMappingWarningNotification'
